<template class="asd">
    <v-container>
        <v-row>
            <v-col class="form__training">
                <div
                    :class="{
                        'display-2': $vuetify.breakpoint.mdAndUp,
                        'display-1': $vuetify.breakpoint.smAndDown,
                    }"
                    class="font-weight-bold text-center mt-12 mb-12"
                >
                    {{title}}
                </div>
                <v-form v-model="valid" @submit.prevent="submit" class="form__training__data rounded-lg pa-2 mx-2 mb-8">
                    <v-container>
                        <v-row v-if="program && program.value=='aplifisa'">
                            <v-col cols="6">
                                <v-text-field
                                    solo
                                    v-model="form.formation_companydb_num1"
                                    :label="formation_companydb_num_label"
                                    :rules="[Boolean(form.formation_companydb_num1) || Boolean(form.formation_companydb_num2) || 'required']"
                                    :error="error_companydb_num"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6">
                                <v-text-field
                                    solo
                                    v-model="form.formation_companydb_num2"
                                    :label="formation_companydb_num_label + ' Fiscal'"
                                    :rules="[Boolean(form.formation_companydb_num1) || Boolean(form.formation_companydb_num2) || 'required']"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row v-else>
                            <v-col cols="12">
                                <v-text-field
                                    solo
                                    v-model="form.formation_companydb_num1"
                                    :label="formation_companydb_num_label"
                                    :rules="requiredRule"
                                    :error="error_companydb_num"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12"
                                :class="{dragging_file:dragging_file}"  
                                @drop="dropFiles"
                                @dragover.stop.prevent="dragging_file=true" 
                                @dragleave.stop.prevent="dragging_file=false"
                            >
                                <v-file-input 
                                    solo
                                    :disabled="submitting"
                                    label="Arrastre aquí sus ficheros para la formación o haga click para seleccionarlos desde la carpeta"
                                    v-model="files"
                                    multiple
                                    :rules="[Boolean(files) || Boolean(form.uploaded_training_docs) || 'required']"
                                />
                            </v-col>
                        </v-row>
                        <v-row class="mt-12">
                            <v-col cols="12" offset-md="6" md="2">
                                <v-btn block @click="cancel">
                                    Cancelar
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-btn block color="secondary" @click="previousStep">
                                    Atrás
                                </v-btn>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-btn
                                    :disabled="!valid || submitting"
                                    block
                                    type="submit"
                                    color="secondary"
                                >
                                    Siguiente
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { client } from "@/api/client";
import { Auth} from "aws-amplify";
import { v4 as uuidv4 } from 'uuid';
import { mapActions, mapGetters, mapState } from "vuex";
import PolicyDialogLink from "./PolicyDialogLink";
import PolicyPrivacity from "./PolicyPrivacity";
import { user as api_user } from "@/api/user";
import { STATUS } from "../../store/modules/me";
import awsconfig from '../../aws-exports';

export default {
    name: "TrainingData",
    components: {
        PolicyDialogLink,
        PolicyPrivacity,
    },
    data() {
        return {
            valid: false,
            submitting: false,
            form: {
                formation_companydb_num1: '',
                formation_companydb_num2: '',
                status: STATUS.READY_FOR_FORMATION,
                uploaded_training_docs: false,
                training_status: 'PENDING_TRAINING'
            },
            files: null,
            requiredRule: [(v) => Boolean(v) || "required"],
            dragging_file: false,
            crispMsg: "Preparando formación",
        };
    },
    created() {
        this.setS3Params();
  

        this.setPrograms();
        this.fillForm();
        this.startCrispThread(this.crispMsg);
    },
    methods: {
        previousStep() {
            this.$emit("previousStep");
        },
        dropFiles(e){
            if(this.form.files != null) {
                this.form.files.push(...Array.from(e.dataTransfer.files));
            } else {
                this.form.files = Array.from(e.dataTransfer.files);
            }
            this.dragging_file = false;
            e.preventDefault();
        },

        upload_file_to_s3(file_name, file) {
            return this.s3.upload({   
                Bucket: awsconfig['aws_user_files_s3_bucket'],     
                Key: file_name,
                Body: file,
                ACL: 'private',
                contentType: 'application/pdf',
                CacheControl: 'max-age=0, public'
            }).promise()
        },
        async cancel() {
            try {
                const response = await api_user.setUserInfo({
                    status: STATUS.ACTIVE
                });
                this.setUserData(response.data.results);
                if (this.currentCompany) {
                this.$router.push('/' + this.currentCompany + '/documents');
                } else {
                this.$router.push("/initial");
                }
            } catch (error) {

            }
        },
        async processFile(file, identityId) {
            const extension = file.name.split('.').pop()
            const uuid = uuidv4()
            const file_name = `private/${identityId}/formation_pdfs/${uuid}_${file.name}`
            try {
                let aux = await this.upload_file_to_s3(file_name, file)
            } catch {
                this.setS3Params();
                let aux = await this.upload_file_to_s3(file_name, file)
            }
            const formData = new FormData();
            formData.append('original_file_name', file.name)
            formData.append('uuid_file', uuid)
            formData.append('extension', extension)
            formData.append('identity_id', identityId)

            try {
                await client.post('formation_documents/', formData);
                // this.snackbarError = false;
            } catch(e) {
                console.debug(e);
                // this.snackbarError = true;
            }
        },


        async submit() {
            this.submitting = true;
            try {
                const cc = await Auth.currentCredentials();
                for (let i = 0; i < this.files.length; i++) {
                    await this.processFile(this.files[i], cc.identityId);
                    this.form.uploaded_training_docs = true;
                }
                const response = await api_user.setUserInfo(this.form);
                await api_user.createLead({'state': 'signup6'});
                this.setUserData(response.data.results);

                this.endCrispThread(this.crispMsg);
            } catch (error) {
                console.error(error);
            } finally {
                this.submitting = false;
            }
        },
        fillForm: function () {
            this.form.formation_companydb_num1 = this.userData.formation_companydb_num1;
            this.form.formation_companydb_num2 = this.userData.formation_companydb_num2;
            this.form.uploaded_training_docs = this.userData.uploaded_training_docs;
        },
        userLoggedIn(providerName, token) {
            this.creds.params.Logins = this.creds.params.Logins || {};
            this.creds.params.Logins[providerName] = token;
            this.creds.expired = true;
        },
        async setS3Params() {
            await this.waitForLoggedIn();
            this.creds = new AWS.CognitoIdentityCredentials({
                IdentityPoolId: awsconfig['aws_cognito_identity_pool_id']
            });
            this.userLoggedIn('cognito-idp.eu-west-1.amazonaws.com/' + awsconfig['aws_user_pools_id'], this.session_information.signInUserSession.idToken.jwtToken)
            AWS.config.update({
                region: awsconfig['aws_user_files_s3_bucket_region'],
                credentials: this.creds,
            });
            this.s3 = new AWS.S3({
                apiVersion: "2006-03-01",
                params: { Bucket: awsconfig['aws_user_files_s3_bucket'] }
            });
        },
        ...mapActions({
            waitForLoggedIn: "waitForLoggedIn",
            setUserData: "me/setUserData",
            setPrograms: "tutorial/setPrograms",
            startCrispThread: "me/startCrispThread",
            endCrispThread: "me/endCrispThread",
        }),
    },
    computed: {
        ...mapState(['session_information', 'currentCompany']),
        ...mapGetters({
            userData: "me/userData",
            programas: "tutorial/programs",
        }),
        program() {
            let that = this;
            let program = this.programas.filter(
                function(data){ return data.id == that.userData.selected_program }
            );
            return program[0];
        },
        title() {
            let aux = '';
            if (this.program && this.program.value == 'aplifisa') {
                aux = 's';
            }
            return '¿Con qué empresa' + aux + ' desea hacer la formación?';
        },
        formation_companydb_num_label() {
            let label = 'Num. Empresa ';
            if (this.program) {
                if (this.program.value == 'contanet') {
                    label = 'Ruta Empresa ';
                }
                label += this.program.name
            }
            return label;
        },
        error_companydb_num() {
            return false;
        },
    },
    watch: {
        userData: function () {
            this.fillForm();
        },
    },
};
</script>
<style scoped>
    .capitalize {
        text-transform: capitalize;
    }
    .dragging_file{
        background: var(--v-neutralDark-base)!important;
        border-radius: 5px;
        border: 2px dashed #ccc;
    }

    .form__training__data {
        background-color: #F2F1FF;
    }

    @media screen and (max-width: 960px) {

        .form__training {
            padding: 0 !important;
        }
    }
</style>
